import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ExamCall } from '../../../../../../models/exam-calls/exam-call';
import { ExamCallService } from '../../../../../../services/exam-call/exam-call.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';

@Component({
    selector: 'download-exam-calls',
    templateUrl: './download-exam-calls.component.html',
    styleUrls: ['./download-exam-calls.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DownloadExamCallsComponent implements OnInit {
    @BlockUI('download-tracker') blockUI: NgBlockUI;
    examCalls: ExamCall[] = [];
    selection: { [key: number]: boolean } = {};
    shifts: any[] = [];
    selectedShiftId: number;
    months: any[] = [
        { id: 1, name: 'MONTHS.JANUARY' },
        { id: 2, name: 'MONTHS.FEBRUARY' },
        { id: 3, name: 'MONTHS.MARCH' },
        { id: 4, name: 'MONTHS.APRIL' },
        { id: 5, name: 'MONTHS.MAY' },
        { id: 6, name: 'MONTHS.JUNE' },
        { id: 7, name: 'MONTHS.JULY' },
        { id: 8, name: 'MONTHS.AUGUST' },
        { id: 9, name: 'MONTHS.SEPTEMBER' },
        { id: 10, name: 'MONTHS.OCTOBER' },
        { id: 11, name: 'MONTHS.NOVEMBER' },
        { id: 12, name: 'MONTHS.DECEMBER' }
    ];
    callNumbers: any[] = [
        { id: 1, name: 'CALL_NUMBERS.FIRST' },
        { id: 2, name: 'CALL_NUMBERS.SECOND' },
        { id: 3, name: 'CALL_NUMBERS.THIRD' },
        { id: 4, name: 'CALL_NUMBERS.FOURTH' },
        { id: 5, name: 'CALL_NUMBERS.FIFTH' },
        { id: 6, name: 'CALL_NUMBERS.SIXTH' },
        { id: 7, name: 'CALL_NUMBERS.SEVENTH' },
        { id: 8, name: 'CALL_NUMBERS.EIGHTH' },
        { id: 9, name: 'CALL_NUMBERS.NINTH' },
        { id: 10, name: 'CALL_NUMBERS.TENTH' }
    ];

    getMonthName(id: number) {
        const month = this.months.find(m => m.id === id);
        return month ? month.name : '';
    }

    getCallNumberName(id: number) {
        const cn = this.callNumbers.find(c => c.id === id);
        return cn ? cn.name : '';
    }

    constructor(
        public dialogRef: MatDialogRef<DownloadExamCallsComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _examCallService: ExamCallService,
        private _shiftService: ShiftService,
        private _translationService: TranslationService,
        private _sweetAlertService: SweetAlertService
    ) {
        if (this._data.examCalls) {
            this.examCalls = this._data.examCalls;
        }
    }

    ngOnInit() {
        this.examCalls.forEach(ec => {
            this.selection[ec.Id] = false;
        });
        this.loadShifts();
    }

    loadShifts() {
        this._shiftService.getAll().subscribe(res => {
            this.shifts = res;
        });
    }

    isAllSelected(): boolean {
        return this.examCalls.length > 0 && this.examCalls.every(ec => this.selection[ec.Id]);
    }

    isSomeSelected(): boolean {
        const selectedCount = this.examCalls.filter(ec => this.selection[ec.Id]).length;
        return selectedCount > 0 && selectedCount < this.examCalls.length;
    }

    toggleAll(checked: boolean) {
        this.examCalls.forEach(ec => {
            this.selection[ec.Id] = checked;
        });
    }

    hasSelection(): boolean {
        return this.examCalls.some(ec => this.selection[ec.Id]);
    }

    confirm() {
        const selectedIds = this.examCalls
            .filter(ec => this.selection[ec.Id])
            .map(ec => ec.Id);

        this.blockUI.start(this._translationService.loading);

        this._examCallService.downloadReports(selectedIds, this.selectedShiftId).subscribe(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'LlamadosExamen.pdf';
            link.click();
            window.URL.revokeObjectURL(url);
            this.blockUI.stop();
            this.dialogRef.close(true);
        }, error => {
            this.blockUI.stop();
            this._sweetAlertService.error('Error', error, null);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-calls/components/download-exam-calls/download-exam-calls.component.ts